// extracted by mini-css-extract-plugin
export default {"maxHeight":"maxHeight--RaM0g"};